export default __webpack_public_path__ + "static/media/chain.58b2966d.png";